export default "/app/global-wrapper-client/static/5cbdedd3b426814a8b6e7954abe8412b.woff2";